<template>
    <div class="flex flex-col flex-1">
        <question-header :question="question" :instructions="instructions" :required="required" class="mb-6 md:mb-10"/>

        <div class="flex flex-col flex-1">
            <div class="flex flex-col flex-1 justify-center">
                <div v-for="(option, index) in options"
                     :key="`option_${index}`"
                     class="mb-12">
                    <p class="block text-muted-500 font-bold text-base md:text-lg mb-8 md:mb-12">{{ option | trans }}</p>
                    <div ref="percentage" :key="`percentage_${index}`"></div>
                </div>
            </div>

            <div v-if="errorMessage" class="w-full py-1 sm:py-2 md:py-3 pl-6 mt-8 md:mt-12 bg-risk-400 rounded-full text-center text-base md:text-2xl text-light-100">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionHeader from './QuestionHeader';
    import * as noUiSlider from 'nouislider';

    export default {
        components: {
            QuestionHeader
        },
        props: {
            question: {
                type: Object,
                required: true
            },
            options: {
                type: Array,
                required: true,
            },
            required: {
                type: Boolean,
                required: true
            },
            instructions: Object,
            answer: Array
        },
        data() {
            let value = [];
            (this.options || [1]).forEach(o => value.push(0));

            return {
                value,
                errorMessage: null
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(data) {
                    const answers = [];
                    data.forEach((value, index) => answers.push({
                        index,
                        value
                    }));

                    this.$emit('input', answers);
                }
            }
        },
        methods: {
            validate() {
                const total = this.value.reduce((total, val) => total += val);
                if (total !== 100) {
                    this.errorMessage =  "Must add up to 100%";
                    return false;
                }

                this.errorMessage = null;
                return true;
            }
        },
        mounted() {
            this.$refs.percentage.forEach((el, index) => {
                const value = this.answer.find(a => a.index === index);
                if (value) {
                    this.$set(this.value, value.index, value.value);
                }

                noUiSlider.create(el, {
                    range: {
                        min: 0,
                        max: 100
                    },
                    start: [value ? value.value : 0],
                    step: 10,
                    tooltips: [true],
                    connect: [true, false],
                    format: {
                        to: value => value + '%',
                        from: value => Number(value.replace('%', ''))
                    }
                }).on('change', value => {
                    this.$set(this.value, index, parseInt(value[0].replace('%', '')));
                });
            });
        }
    }
</script>
